var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoctorSecondaryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#doctorSecondaryIcon_svg__clip0_3734_45022)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 24.023s-1.784-6.842-2.303-7.92c-.269-.557-1.962-1.451-3.79-2.186.044.76.023 1.514-.056 2.23-.035.317-.08.626-.137.928.277.052.547.135.8.251.778.357 1.381 1.007 1.525 1.954.111.741-.125 2.282-.23 2.901a1.295 1.295 0 11-.854-.084c.093-.537.334-2.038.236-2.69-.095-.625-.504-1.06-1.033-1.303a2.768 2.768 0 00-1.143-.236c-.402 0-.8.079-1.143.236-.53.243-.938.678-1.033 1.304-.099.652.142 2.152.235 2.689a1.296 1.296 0 11-.853.084c-.105-.619-.342-2.16-.23-2.901.142-.946.746-1.597 1.525-1.954a3.59 3.59 0 011.336-.313c.06-.31.11-.63.147-.96.087-.788.099-1.632.023-2.475a26.21 26.21 0 00-.949-.326c1.364-.77 2.41-2.201 2.592-4.295h.353c.188 0 .322-.155.342-.343l.224-1.941c.021-.188-.154-.342-.343-.342h-.549V3.239c0-4.084-10.424-4.084-10.424 0v3.092H6.22c-.189 0-.365.155-.343.342L6.1 8.614c.022.188.154.343.344.343h.353c.182 2.094 1.228 3.525 2.592 4.295-.332.106-.674.224-1.019.351a12.323 12.323 0 00.165 3.374c.12.617.287 1.194.493 1.716a1.296 1.296 0 11-.872.12c-.19-.519-.347-1.08-.462-1.675a13.117 13.117 0 01-.207-3.193c-1.802.729-3.456 1.607-3.722 2.157-.519 1.078-2.303 7.92-2.303 7.92 4.72 4.061 16.317 4.061 21.037 0l.001.001zM15.94 8.297V6.164H8.023v2.133c0 1.229.336 2.445 1.243 3.315.728.698 1.713 1.057 2.715 1.057 1.003 0 1.988-.359 2.715-1.057.907-.87 1.243-2.087 1.243-3.315zM8.757 19.425a.536.536 0 100 1.073.536.536 0 000-1.073zm9.004 3.396a.536.536 0 11.001 1.072.536.536 0 010-1.072zm-4.492 0a.535.535 0 10-.001 1.07.535.535 0 000-1.07z",
    fill: "url(#doctorSecondaryIcon_svg__paint0_linear_3734_45022)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "doctorSecondaryIcon_svg__paint0_linear_3734_45022",
    x1: 22.5,
    y1: 27.068,
    x2: 1.462,
    y2: 27.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BCEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#98D3F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#92E1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DECE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "doctorSecondaryIcon_svg__clip0_3734_45022"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h22v28H0z"
  })))));
}

export default SvgDoctorSecondaryIcon;